import { useTranslation } from "@volcengine/i18n"
import { useEffect } from "react"
const isEnvDevelopment = process.env.NODE_ENV === "development"

function getCookie(name: string) {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) return parts.pop()?.split(";").shift()
}

const specialLangMap: Record<string, string> = {
  ja: "ja-JP",
}

const transSpecialLang = (lang: string) => {
  if (lang.indexOf("es-") > -1) {
    return "es-LA"
  }
}

export function getLanguage() {
  if (isEnvDevelopment) {
    return getCookie("lang") || "en"
  }
  if (typeof window === "undefined") return ""
  const navigator = window.navigator
  const lang = navigator.language

  return specialLangMap[lang] || transSpecialLang(lang) || lang
}

const useLanguageTrans = () => {
  const { t, i18n } = useTranslation()
  useEffect(() => {
    const lang = getLanguage()
    i18n.changeLanguage(lang)
  }, [i18n])
  return [t, i18n] as const
}

export default useLanguageTrans
